export default __webpack_public_path__ + "c269f3cadb03f4415b0e6d0cf0c07e9c.svg";